//var apibaseurl = "http://localhost:52542/api/" 
//  var apibaseurl = "http://localhost:5092/api/" //lambda local
//var apibaseurl = "http://13.127.225.87/api/"
//var apibaseurl = "https://c5zpcpv4fh.execute-api.ap-south-1.amazonaws.com/Prod/api/" //lambda - uat
// var apibaseurl = "https://api.msobcfdc.in/api/"
///var apibaseurl = "https://1qff208s9a.execute-api.ap-south-1.amazonaws.com/Prod/api/" //lambda - prod
var apibaseurl = "https://api.msobcfdc.in/api/" //lambda - prod
import Vue from 'vue'
import VueResource from 'vue-resource';
import store from '../store'

//const header = {Authorization: store.getters.authToken};

export default {
    login(user) {
        return Vue.http.post(apibaseurl + 'Login/ValidateUser', user, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    ValidateLoanUser(user) {
        return Vue.http.post(apibaseurl + 'Signup/ValidateMobile', user, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    signup(user) {
        return Vue.http.post(apibaseurl + 'Signup/SignupUser', user, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    frgot(user) {
        return Vue.http.post(apibaseurl + 'Signup/ForgotPassword', user, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    sendOTP(otpvalidation) {
        return Vue.http.post(apibaseurl + 'Login/sendOTP', otpvalidation, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    validateOTP(otpvalidation) {
        return Vue.http.post(apibaseurl + 'Login/validateOTP', otpvalidation, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    //Dashboad APIs
    getSchemes() {
        return Vue.http.get(apibaseurl + 'Scheme/ReadSchemes', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getSchemeEligibility(id) {
        return Vue.http.get(apibaseurl + 'Scheme/ReadSchemeEligibility/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getDownloads() {
        return Vue.http.get(apibaseurl + 'Scheme/Downloads', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getSchemeGuidelines(id) {
        return Vue.http.get(apibaseurl + 'Scheme/ReadSchemeGuidelines/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getSchemeGuidelineDetails(id) {
        return Vue.http.get(apibaseurl + 'Scheme/ReadSchemeGuidelinesDetails/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    applyForScheme(eventid, userid) {
        return Vue.http.get(apibaseurl + 'Events/GenerateUserApplicatioNo/' + eventid + '/' + userid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Get Masters for the Registration
    getReligion() {
        return Vue.http.get(apibaseurl + 'Masters/ReadAllReligionType', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getCategory() {
        return Vue.http.get(apibaseurl + 'Masters/ReadAllCategoryType', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getStates() {
        return Vue.http.get(apibaseurl + 'Masters/ReadAllState', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getCaste() {
        return Vue.http.get(apibaseurl + 'Masters/ReadAllCaste', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getDistricts(stateid) {
        return Vue.http.get(apibaseurl + 'Masters/ReadDistrictByStateID/' + stateid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getTaluka(districtid) {
        return Vue.http.get(apibaseurl + 'Masters/ReadTalukaByDistID/' + districtid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getBoards(institute, stateid) {
        return Vue.http.get(apibaseurl + 'Masters/ReadBoardByStateID/' + institute + "/" + stateid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getQualifications() {
        return Vue.http.get(apibaseurl + 'Masters/ReadQualificationType', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getDegreeTypes(qualifn) {
        return Vue.http.get(apibaseurl + 'Masters/ReadDegreeByQualificationTypeID/' + qualifn, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Registration
    saveQualification(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserQualifications', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadUserQualification(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserQualification/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveDirector(user) {
        return Vue.http.post(apibaseurl + 'Group/SaveGroupDirector', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Remove Family member details
    deleteDirector(user) {
        return Vue.http.get(apibaseurl + 'Group/DeleteGroupDirectors/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Nominations
    ReadDirectors(user) {
        return Vue.http.get(apibaseurl + 'Group/ReadGroupDirectors/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveShareholder(user) {
        return Vue.http.post(apibaseurl + 'Group/SaveGroupShareholder', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Remove Family member details
    deleteShareholder(user) {
        return Vue.http.get(apibaseurl + 'Group/DeleteGroupShareholder/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Nominations
    ReadShareholder(user) {
        return Vue.http.get(apibaseurl + 'Group/ReadGroupShareholder/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveGroup(user) {
        return Vue.http.post(apibaseurl + 'Group/SaveGroupInfo', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadGroup(user) {
        return Vue.http.get(apibaseurl + 'Group/ReadGroupInfo/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Nomination
    saveNomination(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserNomination', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Remove Family member details
    deleteNominee(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserNomineeDetailsRm', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Nominations
    ReadUserNominations(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserNomineeByUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Physical Details
    savePhysicalDetails(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserPhysicalDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveLendingLoanDetails(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserLendingLoanDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    saveBankDetails(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserBankDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    //Read Physical Details
    ReadUserPhysicalDetails(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserPhysicalDetails/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadUserLendingLoanDetails(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserLendingLoanDetails/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadBankDetails(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserBankDetails/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    //Save Declaration
    saveUserDeclaration(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserDeclaration', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    saveLoanApplication(user) {
        return Vue.http.post(apibaseurl + 'Registration/saveLoanApplication', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Declaration
    ReadUserDecleration(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserDecleration/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //save Personal Details
    saveUserRegistration(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserRegistration', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Personal Details ReadUserDetailByUserID
    ReadUserDetail(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserDetailByUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
        //return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadUserQualification/'+ user);
    },

    ReadUserDetail2(user) {
        //return Vue.http.get(apibaseurl + 'Registration/ReadUserDetailByUserID/'+ user);
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadUserQualification/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadGroupProfile(user) {
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadGroupProfile/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadLOI(id) {
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadLOI/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadPastLOI(id) {
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadPastLOI/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadUserDetailByIndivisual(user) {
        //return Vue.http.get(apibaseurl + 'Registration/ReadUserDetailByUserID/'+ user);
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadUserDetailByIndivisual/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadUserDetailByGroup(user) {
        //return Vue.http.get(apibaseurl + 'Registration/ReadUserDetailByUserID/'+ user);
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadUserDetailByGroup/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadApprovalRemarks(id) {
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadApprovalRemarks/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadApprovalRemarksLink(id) {
        return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadApprovalRemarksLink/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    //Read Personal Details ReadUserDetailByUserID
    ReadUserOtherDetails(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserOtherDetails/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
        //return Vue.http.get(apibaseurl + 'ProfilePrinting/ReadUserQualification/'+ user});
    },
    getAppData() {
        return Vue.http.get(apibaseurl + 'Login/getLoanSummary/', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    saveUserOtherDetails(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserOtherDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Address
    saveUserAddress(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserAddress', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    saveLoanUserAddress(user) {
        return Vue.http.post(apibaseurl + 'Registration/LoanUserAddress', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadUseCorrespondanceAddress(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUseCorrespondanceAddressByUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadLoanUseCorrespondanceAddress(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadLoanUseCorrespondanceAddressByUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadUserPermanentAddress(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserPermanentAddressByUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadUserEmgContactDetails(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserEmgContactDetailsByUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //save experience
    saveUserExperience(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserExperience', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadUserExperience(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserExprienceDetails/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //summary tab
    ReadUsePrfileStatus(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUsePrfileStatus/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Save Family member details
    saveFamilyMember(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserFamilyMember', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Remove Family member details
    deleteFamilyMember(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserFamilyMemberRm', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    //Read Familymembers
    ReadFamilyMembers(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserFamilyDetailbyUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadRelations() {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserRelationship', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveDocumentPath(user) {
        //UserDocumentDetails
        return Vue.http.post(apibaseurl + 'Registration/UserDocumentDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    saveLoanDocumentPath(user) {
        //UserDocumentDetails
        return Vue.http.post(apibaseurl + 'Registration/UserLoanDocumentDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveDocumentPathVeri(user) {
        //UserDocumentDetails
        return Vue.http.post(apibaseurl + 'Registration/UserVeriDocumentDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    readDocumentPath(user) {

        return Vue.http.get(apibaseurl + 'Registration/ReadUserDocuments/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    readLoanDocumentPath(user) {

        return Vue.http.get(apibaseurl + 'Registration/ReadLoanUserDocuments/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    readVeriDocumentPath(user) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserVeriDocuments/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadUserDetails(id) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserDetails', id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    saveDocumentStatus(user) {
        return Vue.http.post(apibaseurl + 'Registration/UserDocumentDetails', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getDashbord(boardid) {
        return Vue.http.get(apibaseurl + 'db/getdashboardsummary/' + boardid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },


    // saveBankDetails(user) {
    //     return Vue.http.post(apibaseurl + 'Signup/SignupUser', user,{
    //         headers: {
    //             "Content-Type": "application/json"
    //         }
    //     });
    // },

    SignUpLoanUser(user) {
        //return Vue.http.post(apibaseurl + 'LoanSignup/SignupUser', user, {
        return Vue.http.post(apibaseurl + 'Signup/SignupUser', user, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    getApplicationSummary(districtid) {
        return Vue.http.get(apibaseurl + 'AdminUser/ReadApplicationSummary/' + districtid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getApplicationSummaryMD(loanType) {
        return Vue.http.get(apibaseurl + 'AdminUser/ReadApplicationSummaryDistrictStatus/' + loanType, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getApplicationStatusMstr() {
        return Vue.http.get(apibaseurl + 'AdminUser/ReadApplicationStatus', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getClaimStatusMstr() {
        return Vue.http.get(apibaseurl + 'AdminUser/ReadClaimStatus', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getPaymentStatusMstr() {
        return Vue.http.get(apibaseurl + 'AdminUser/ReadClaimPaymentStatus', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadApplicationList(filter) {
        return Vue.http.post(apibaseurl + 'AdminUser/ReadApplicationList', filter, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    UpdateApplicationStatus(Application) {
        return Vue.http.post(apibaseurl + 'AdminUser/UpdateApplicationStatus', Application, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ApplyforExtension(Application) {
        return Vue.http.post(apibaseurl + 'Registration/ApplyforExtension', Application, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    UpdateClaimStatus(claim) {
        return Vue.http.post(apibaseurl + 'ClaimEMI/UpdateClaimStatus', claim, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getBankAccount() {
        return Vue.http.get(apibaseurl + 'AdminUser/ReadUserBankAccount', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    SaveBankAccount(account) {
        return Vue.http.post(apibaseurl + 'Registration/UserBankAccount', account, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    getUserBankDetails(id) {
        return Vue.http.get(apibaseurl + 'Registration/ReadUserBankAccount/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    saveConfirmPassword(user) {
        return Vue.http.post(apibaseurl + 'Login/saveConfirmPassword', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    changePassword(user) {
        return Vue.http.post(apibaseurl + 'Login/saveConfirmPasswordAdmin', user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    changeDistrict(appnum) {
        return Vue.http.post(apibaseurl + 'AdminUser/ChangeDistrict', appnum, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadRejectTypes() {
        return Vue.http.get(apibaseurl + 'Masters/ReadRejectedType', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadClaimRejectionReason() {
        return Vue.http.get(apibaseurl + 'Masters/ReadClaimRejectionReason', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadCompanyTypes() {
        return Vue.http.get(apibaseurl + 'Masters/ReadCompanyTypes', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadSummaryReports(districtid) {
        return Vue.http.get(apibaseurl + 'MISReport/ReadApplicationSummary/' + districtid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    CreateBatch(batchdetails) {
        return Vue.http.post(apibaseurl + 'BatchSchedule/CreateBatch', batchdetails, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    UpdateBSCDetails(bscdetails) {
        return Vue.http.post(apibaseurl + 'BatchSchedule/UpdateBSCDetails', bscdetails, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadLoanDisbursementByUserID(user) {
        return Vue.http.get(apibaseurl + 'LoanDisbursement/ReadLoanDisbursementByUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadSanctionLetterByUserID(user) {
        return Vue.http.get(apibaseurl + 'LoanDisbursement/ReadSanctionLetterByUserID/' + user, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveSanctionLetter(form) {
        return Vue.http.post(apibaseurl + 'LoanDisbursement/SaveSanctionLetter', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveDisbursement(form) {
        return Vue.http.post(apibaseurl + 'LoanDisbursement/SaveLoanDisbursement', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadDisbursementByQuery(form) {
        return Vue.http.post(apibaseurl + 'LoanDisbursement/ReadDisbursementQuery', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadBankMaster() {
        return Vue.http.get(apibaseurl + 'LoanDisbursement/ReadBanks', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadBankBranch(id) {
        return Vue.http.get(apibaseurl + 'BankMaster/ReadBankBranch/' + id, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getSehedule(applicationid) {
        return Vue.http.get(apibaseurl + 'EMI/ReadEMISchedule/' + applicationid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    getSeheduleByDisbursement(disbursementId) {
        return Vue.http.get(apibaseurl + 'EMI/ReadEMIScheduleByDisbursement/' + disbursementId, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveClaim(form) {
        return Vue.http.post(apibaseurl + 'ClaimEMI/SaveClaimEMI', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    readClaims(userId) {
        return Vue.http.get(apibaseurl + 'ClaimEMI/ReadClaimEMIByUserID/' + userId, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    readAllClaims(form) {
        return Vue.http.get(apibaseurl + 'ClaimEMI/ReadClaimEMIForApproval/' + form.ClaimStatus + '/' + form.ClaimPaidStatus + '/0/' + form.DistrictID,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + store.getters.authToken
                }
            });
    },
    ReadClaimEMIForApproval(form) {
        return Vue.http.post(apibaseurl + 'ClaimEMI/ReadClaimEMIForApproval', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    UpdateBSCDetails(formBSC) {
        return Vue.http.post(apibaseurl + 'BatchSchedule/UpdateBSCDetails', formBSC, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    createBatch(formBatch) {
        return Vue.http.post(apibaseurl + 'BatchSchedule/CreateBatch', formBatch, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    saveDMChanges(dmChanges) {
        return Vue.http.post(apibaseurl + 'AdminUser/DmChanges', dmChanges, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadSanctionLetterQuery(query) {
        return Vue.http.post(apibaseurl + 'LoanDisbursement/ReadSanctionLetterQuery', query, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadClaimStatusByRole(query) {
        return Vue.http.post(apibaseurl + 'LoanDisbursement/ReadClaimStatusByRole', query, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadClaimDashBoard(id) {
        return Vue.http.get(apibaseurl + 'ClaimEMI/ReadClaimsDashboard/', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadApplicationStatusByRoleStatus(form) {
        return Vue.http.post(apibaseurl + 'AdminUser/RoleStatusMappingByAppStatus', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ExtendLoi(form) {
        return Vue.http.post(apibaseurl + 'AdminUser/ExtendLoi', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadMasters() {
        return Vue.http.get(apibaseurl + 'Reports/GetMasters', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    GetReportCategory(category) {
        return Vue.http.post(apibaseurl + 'Reports/GetSubCategories/', category, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    GetReportMaster(category) {
        return Vue.http.post(apibaseurl + 'Reports/GetCategoryWiseReports/', category, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    GetReportParameters(category) {
        return Vue.http.post(apibaseurl + 'Reports/GetReportWiseParameters/', category, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    GetReportDetails(report) {
        return Vue.http.post(apibaseurl + 'Reports/GetReport/', report, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    UploadEmiSchedule(form) {
        return Vue.http.post(apibaseurl + 'LoanDisbursement/UploadEmiSchedule', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    UpdateClaimPayment(form) {
        return Vue.http.post(apibaseurl + 'ClaimEMI/UpdateClaims', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadClaimApprovalRemarks(claimid) {
        return Vue.http.get(apibaseurl + 'ClaimEMI/ReadApprovalRemarks/' + claimid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },

    ReadDocumentType() {
        return Vue.http.get(apibaseurl + 'DocumentChangeLog/ReadDocumentType', {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ReadDocumentChangeLog(AppId, DocTypeID) {
        return Vue.http.get(apibaseurl + 'DocumentChangeLog/ReadChangeLog/' + AppId + '/' + DocTypeID, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    SaveDocumentChangeLog(form) {
        return Vue.http.post(apibaseurl + 'DocumentChangeLog/SaveChangeLog', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    updateLoanSanction(form){
        return Vue.http.post(apibaseurl + 'LoanDisbursement/UpdateLoanSanction', form, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    readNotifications(userid){
        return Vue.http.get(apibaseurl + 'Login/ReadNotification/'+userid, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    GenerateChatbotReportUrl(request) {
        return Vue.http.post(apibaseurl + 'Chatbot/GenerateChatbotReportUrl', request, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    ExecuteAdvancedSqlReport(request) {
        return Vue.http.post(apibaseurl + 'Chatbot/ExecuteAdvancedSqlReport', request, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    },
    QueryByNaturalLanguage(request) {
        return Vue.http.post(apibaseurl + 'Chatbot/QueryByNaturalLanguage', request, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + store.getters.authToken
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/apis/index.js